module.exports = __webpack_public_path__ + "static/media/client-logo.a354dff5.svg";